import {Routes} from '@angular/router';
import {AccessGuard} from './access-guard';
import {AddInAccessGuard} from './addin-v2/addin-access-guard';
import {authRoutes} from './new/registration/auth.routes';

export const routes: Routes = [
  {
    path: '_addin',
    loadChildren: () => import('./addin-v2/addin-v2.routes').then(m => m.addinV2Routes),
    canActivate: [AddInAccessGuard]
  },
  {
    path: 'auth',
    children: authRoutes,
  },
  {
    path: '',
    loadChildren: () => import('./new/app.routes').then(m => m.routes),
    canActivate: [AccessGuard]
  },
];
